import React, { useEffect, useState } from 'react'
import "react-quill/dist/quill.snow.css";
import "./quill.css";

export default function ContentPrivacyPolicy() {

    const Api_Url = process.env.REACT_APP_API_BASE_URL;

    const [policy, setPolicy] = useState([]);


    useEffect(() => {
        fetch(`${Api_Url}/privacy-policy`)
            .then((res) => res.json())
            .then((data) => { setPolicy(data) })
    }, []);

    return (
        <div className='w-[80%] mx-auto'>
            <div
                className="ql-editor text-end text-[#333] dark:text-white content-visibility-auto"
                dangerouslySetInnerHTML={{ __html: policy[0]?.privacy_policy_content }}
            />
        </div>
    )
}
